import { PayButtonByDevice } from '@/components/PayButtonByDevice/PayButtonByDevice';
import { AdyenGooglePay } from '@/components/Wallets/AdyenGooglePay/AdyenGooglePay';
import { AdyenApplePay } from '@/components/Wallets/AdyenApplePay/AdyenApplePay';
import type { AvailablePaymentMethod } from '@/types/checkout';
import { PaymentMethodEnum, ProviderEnum } from '@/types/common';
import type { ComponentType } from 'react';
import { PaypalForm } from '@/components/PaymentForms/Paypal';

export interface ExpressComponentConfig {
  key: string;
  Component: ComponentType<ExpressCheckoutComponentProps>;
  providers: ProviderEnum[];
  paymentMethodNames: PaymentMethodEnum[];
}

export interface ExpressCheckoutComponentProps {
  onReady?: (isAvailable: boolean) => void;
}

const EXPRESS_COMPONENT_CONFIG: ExpressComponentConfig[] = [
  {
    key: 'AdyenApplePay',
    Component: AdyenApplePay,
    providers: [ProviderEnum.ADYEN],
    paymentMethodNames: [PaymentMethodEnum.APPLE_PAY],
  },
  {
    key: 'StripeExpressCheckout',
    Component: PayButtonByDevice,
    providers: [ProviderEnum.STRIPE],
    paymentMethodNames: [PaymentMethodEnum.APPLE_PAY, PaymentMethodEnum.GOOGLE_PAY],
  },
  {
    key: 'AdyenGooglePay',
    Component: AdyenGooglePay,
    providers: [ProviderEnum.ADYEN],
    paymentMethodNames: [PaymentMethodEnum.GOOGLE_PAY],
  },
  {
    key: 'BraintreeExpressCheckout',
    Component: PaypalForm,
    providers: [ProviderEnum.BRAINTREE, ProviderEnum.PAYPAL],
    paymentMethodNames: [PaymentMethodEnum.PAYPAL],
  },
];

export const filterExpressComponents = (paymentMethods: AvailablePaymentMethod[]): ExpressComponentConfig[] => {
  return EXPRESS_COMPONENT_CONFIG.filter((config) =>
    Boolean(
      paymentMethods.find(
        (pm) =>
          pm.isExpress &&
          config.providers.includes(pm.provider as ProviderEnum) &&
          config.paymentMethodNames.includes(pm.paymentMethodName as PaymentMethodEnum)
      )
    )
  );
};
